import React from 'react';

import PropTypes from 'prop-types';

import {
  EnvironmentStyled,
  LinkStyled,
  IconStyled,
} from './environment.styled';

export default function Environment({ name }) {
  // TODO:
  // always return this once we have the Community page.
  if (name === 'workspace') {
    return (
      <LinkStyled name='home.workspace'>
        <EnvironmentStyled>
          <IconStyled name={name} size='small' /> {name}
        </EnvironmentStyled>
      </LinkStyled>
    );
  }
  return (
    <LinkStyled name='home' params={{ section: name }}>
      <EnvironmentStyled>
        <IconStyled name={name} size='small' /> {name}
      </EnvironmentStyled>
    </LinkStyled>
  );
}

Environment.propTypes = {
  name: PropTypes.string,
};
